import React, { createContext, useState } from 'react'
import { ICalendarEventType } from 'interface/calendar'
import { Ioffice } from 'interface'
import { IEmployee } from 'interface/employee'
import { mockupRegions } from 'constants/mockup'

interface CalendarContextInterface {
  eventTypes: ICalendarEventType[];
  setEventTypes: React.Dispatch<React.SetStateAction<ICalendarEventType[]>>;
  selectedOffice: Ioffice;
  setSelectedOffice: React.Dispatch<React.SetStateAction<Ioffice>>;
  officeEmployees: IEmployee[];
  setOfficeEmployees: React.Dispatch<React.SetStateAction<IEmployee[]>>;
  calendarMode: number;
  setCalendarMode: React.Dispatch<React.SetStateAction<number>>;
}

export const CalendarStateContext = createContext<CalendarContextInterface>({
  eventTypes: [],
  setEventTypes: () => {},
  selectedOffice: {} as Ioffice,
  setSelectedOffice: () => {},
  officeEmployees: [],
  setOfficeEmployees: () => {},
  calendarMode: 1,
  setCalendarMode: () => {},
})

export const CalendarStateProvider: React.FC = ({ children }) => {
  const [eventTypes, setEventTypes] = useState<ICalendarEventType[]>([])
  const [selectedOffice, setSelectedOffice] = useState<Ioffice>(
    mockupRegions.result[0].offices[0]
  )
  const [officeEmployees, setOfficeEmployees] = useState<IEmployee[]>([])
  const [calendarMode, setCalendarMode] = useState(1)

  const calendarContextValue: CalendarContextInterface = {
    eventTypes,
    setEventTypes,
    selectedOffice,
    setSelectedOffice,
    officeEmployees,
    setOfficeEmployees,
    calendarMode,
    setCalendarMode
  }

  return (
    <CalendarStateContext.Provider value={calendarContextValue}>
      {children}
    </CalendarStateContext.Provider>
  )
}
